const LINK_TYPE = "LINK";
export {
  LINK_TYPE
};
//# sourceMappingURL=types.js.map
